import * as Types from './types';

const { ThunkTypes } = Types;

export const ThunkSuccess = <T = any>({ meta, payload }: Types.ThunkPayload<T>): Types.ThunkSuccessAction<T> => ({
    type: ThunkTypes.Success,
    meta,
    payload,
});

export const ThunkError = <T = any>({ meta, payload }: Types.ThunkPayload<T>): Types.ThunkErrorAction<T> => ({
    type: ThunkTypes.Error,
    meta,
    payload,
    error: true,
});
